import "../styles/Sidebar.css";
import { useAuth } from "../context/AuthContext";
import inicioIcon from "../assets/ic_book.png";
import planIcon from "../assets/ic_calendar.png";
import frankitoIcon from "../assets/ic_frankito.png";
import rankingIcon from "../assets/ic_podium2.png";
import controlIcon from "../assets/ic_teacher.png";
import LogOutIcon from "../assets/ic_logout.png";
import { showLogoutConfirm } from "../utils/alerts";

function Sidebar() {
  const { logout } = useAuth();

  const handleLogout = async () => {
    try {
      showLogoutConfirm(logout);
      //await logout();
      //window.location.href = "/login";
    } catch (error) {
      console.error("Error al cerrar sesión:", error);
    }
  };

  return (
    <div className="sidebar">
      <ul>
        <li>
          <img src={inicioIcon} alt="Inicio" className="sidebar-icon" />
          <span className="sidebar-label">Inicio</span>
        </li>
        <li>
          <img src={planIcon} alt="Plan" className="sidebar-icon" />
          <span className="sidebar-label">Plan de estudios</span>
        </li>
        <li>
          <img src={frankitoIcon} alt="Frankito" className="sidebar-icon" />
          <span className="sidebar-label">Frankito</span>
        </li>
        <li>
          <img src={rankingIcon} alt="Ranking" className="sidebar-icon" />
          <span className="sidebar-label">Ranking</span>
        </li>
        <li>
          <img src={controlIcon} alt="Control" className="sidebar-icon" />
          <span className="sidebar-label">Control</span>
        </li>
        <li onClick={handleLogout}>
          <img src={LogOutIcon} alt="Logout" className="sidebar-icon" />
          <span className="sidebar-label">Cerrar sesión</span>
        </li>
      </ul>
    </div>
  );
}

export default Sidebar;
